export const LAYOUT = {
  top: 140,
}

export const EMAIL_CONTACT = "contact@collectif-hinterland.org"
